<template>
  <div class="firm-workbench">
    <el-alert
      type="success"
      :closable="false"
      show-icon
      :title="`已登录：${ctx?.firmName || firmName || '—'}`"
      :description="desc"
      class="mb-16px"
    />

    <div class="section-title">待办</div>
    <el-row :gutter="16" class="mb-16px">
      <el-col :xs="12" :sm="6">
        <el-card shadow="hover" class="stat-card todo" @click="goOpportunity('assignable')">
          <template #header>待指派</template>
          <div class="stat">{{ ctx?.assignableCount ?? '—' }}</div>
          <div class="hint">可指派池</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="6">
        <el-card shadow="hover" class="stat-card todo" @click="goOpportunity('mine', 'SERVING')">
          <template #header>服务中</template>
          <div class="stat">{{ ctx?.servingCount ?? '—' }}</div>
          <div class="hint">本所商机</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="6">
        <el-card shadow="hover" class="stat-card todo" @click="go('/lawyer', { verifyStatus: 'PENDING' })">
          <template #header>待审挂靠</template>
          <div class="stat">{{ ctx?.pendingLawyerCount ?? '—' }}</div>
          <div class="hint">等平台审核</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="6">
        <el-card shadow="hover" class="stat-card todo" @click="go('/settle', { tab: 'applies' })">
          <template #header>结算审核中</template>
          <div class="stat">{{ ctx?.pendingSettleCount ?? '—' }}</div>
          <div class="hint">本所申请</div>
        </el-card>
      </el-col>
    </el-row>

    <div class="section-title">本所概况</div>
    <el-row :gutter="16">
      <el-col :xs="12" :sm="6">
        <el-card shadow="hover" class="stat-card" @click="go('/lawyer')">
          <template #header>本所律师</template>
          <div class="stat">{{ ctx?.lawyerCount ?? '—' }}</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="6">
        <el-card shadow="hover" class="stat-card" @click="goOpportunity('mine')">
          <template #header>本所商机</template>
          <div class="stat">{{ ctx?.opportunityCount ?? '—' }}</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="6">
        <el-card shadow="hover" class="stat-card" @click="go('/case')">
          <template #header>本所正式案件</template>
          <div class="stat">{{ ctx?.caseCount ?? '—' }}</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="6">
        <el-card shadow="never">
          <template #header>经营模式</template>
          <div class="stat mode">{{ ctx?.bizMode || '—' }}</div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { getFirmWorkbenchContext } from '@/api/firm/auth'
import { firmPath } from '@/views/firm-portal/registry/paths'

defineOptions({ name: 'FirmWorkbench' })

const router = useRouter()
const ctx = ref<Awaited<ReturnType<typeof getFirmWorkbenchContext>> | null>(null)
const firmName = ref(localStorage.getItem('firmName') || '')

const desc = computed(() => {
  const parts = [
    ctx.value?.canonical ? '官方本所' : null,
    ctx.value?.firmStatus ? `状态 ${ctx.value.firmStatus}` : null,
    ctx.value?.firmId ? `firmId=${ctx.value.firmId}` : null
  ].filter(Boolean)
  return parts.length ? parts.join(' · ') : '本所经营待办与概况'
})

const go = (suffix: string, query?: Record<string, string>) =>
  router.push({ path: firmPath(suffix), query })

const goOpportunity = (tab: 'mine' | 'assignable', status?: string) => {
  const query: Record<string, string> = { tab }
  if (status) query.status = status
  go('/opportunity', query)
}

onMounted(async () => {
  ctx.value = await getFirmWorkbenchContext()
  if (ctx.value?.firmName) firmName.value = ctx.value.firmName
})
</script>

<style scoped>
.section-title {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #475569;
}
.stat {
  font-size: 28px;
  font-weight: 600;
  color: #1e3a3a;
}
.stat.mode {
  font-size: 20px;
}
.hint {
  margin-top: 4px;
  font-size: 12px;
  color: #94a3b8;
}
.stat-card {
  cursor: pointer;
  margin-bottom: 12px;
}
.stat-card.todo :deep(.el-card__header) {
  color: #0f766e;
}
</style>
